module.exports = __webpack_public_path__ + "img/Oman.9d97ecc9.gif";